import { type VFC } from "react";
import { useSelector } from "react-redux";

import { type Configuration } from "../../graphql.js";
import { filterByLicense } from "../../redux/modules/config.js";
import { type IAppState } from "../../redux/reducer.js";
import { EXT_APP_MODULES, LICENSE_MODULE } from "../../settings/settings.js";
import PageLayout from "../core/navigation-panel/PageLayout.js";
import { type IRouteNavItemProps } from "../core/navigation-panel/RouteNavItem.js";
import SystemDetailsPage from "./SystemDetailsPage.js";

const ADMIN_SYSTEM_NAV_ITEMS: IRouteNavItemProps[] = [
  {
    route: "analyst",
    label: EXT_APP_MODULES.ANALYST.name,
    licenseModule: LICENSE_MODULE.ANALYST,
    pageComponent: <SystemDetailsPage systemId={EXT_APP_MODULES.ANALYST.id} />,
    default: true,
  },
  {
    route: "processor",
    label: EXT_APP_MODULES.PROCESSOR.name,
    licenseModule: LICENSE_MODULE.PROCESSOR,
    pageComponent: <SystemDetailsPage systemId={EXT_APP_MODULES.PROCESSOR.id} />,
  },
];

/**
 * System Admin Page main component
 */
const SystemAdminPage: VFC = () => {
  const configuration = useSelector<IAppState, Configuration>((state) => state.config.configuration);

  return (
    <PageLayout
      navPanelCategories={[
        {
          label: "System Administration",
          navItems: filterByLicense(ADMIN_SYSTEM_NAV_ITEMS, configuration),
        },
      ]}
    />
  );
};

export default SystemAdminPage;
